import React from 'react';
import { BookOpen, CheckCircle2, Circle, Layers, Repeat2, Star, Trophy } from 'lucide-react';
import { buildVocabularyProgressCounts, vocabularyGrade } from '../utils/vocabularyPresentation';
import { formatCompactInteger } from '../utils/numberFormat';
import { t } from '../i18n';
import './NoteStatsPanel.css';
import './PracticeSummaryProgress.css';
import './VocabularyNoteStats.css';

const PROGRESS_STAGES = [
  ['completed', CheckCircle2, 'terminalComplete'],
  ['learning', BookOpen, 'activeCard'],
  ['unlearned', Circle, 'editorUnlearned'],
];

export default function VocabularyNoteStats({ cards, title }) {
  const count = cards.length;
  const average = field => count ? cards.reduce((sum, card) => sum + (Number(card[field]) || 0), 0) / count : 0;
  const grade = count ? cards.reduce((sum, card) => sum + vocabularyGrade(card), 0) / count : 0;
  const progress = buildVocabularyProgressCounts(cards);
  const excluded = count - progress.total;
  const metrics = [['cards', count, Layers], ['repeats', formatCompactInteger(average('repeatCount')), Repeat2],
    ['score', formatCompactInteger(average('totalPoints')), Trophy], ['grade', grade.toFixed(1), Star]];
  return <section className="note-stats-panel" aria-label={t('learningNavigation.stats.accessibleTitle', undefined, { name: title })}>
    <div className="note-stats-summary-grid">{metrics.map(([key, value, Icon]) => <div className="note-stats-stat" key={key}>
      <Icon className="note-stats-stat-icon" size={22} aria-hidden="true" /><span className="note-stats-stat-value">{value}</span><span className="note-stats-stat-label">{t(`learningNavigation.stats.${key}`)}</span>
    </div>)}</div>
    <section className="practice-summary-progress vocabulary-note-progress" aria-label={t('learningNavigation.stats.progressAria')}>
      <div className="practice-summary-heading"><div>
        <h3>{t('learningNavigation.stats.progress')}</h3>
        <p>{t('vocabulary.progressDescription')}</p>
      </div></div>
      <div className="practice-summary-flow vocabulary-progress-flow">
        {PROGRESS_STAGES.map(([key, Icon, label]) => <div key={key} className={`practice-summary-stage is-${key}`}>
          <span className="practice-summary-stage-icon"><Icon size={21} strokeWidth={2.4} aria-hidden="true" /></span>
          <strong>{progress[key].toLocaleString()}</strong>
          <span>{t(`vocabulary.${label}`)}</span>
        </div>)}
      </div>
      <div className="practice-summary-composition" role="img" aria-label={t('vocabulary.progressComposition', undefined, progress)}>
        {PROGRESS_STAGES.map(([key]) => <span key={key} className={`is-${key}`} aria-hidden="true" style={{ width: `${progress.total ? progress[key] / progress.total * 100 : 0}%` }} />)}
      </div>
    </section>
    {excluded > 0 && <p className="vocabulary-progress-excluded">{t('vocabulary.progressExcluded', undefined, { count: excluded })}</p>}
  </section>;
}
